import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import styles from './twoColumnLayoutChildPage.module.scss';

export default function TwoColumnLayoutChildPage({ headline = '', body = '' }) {
  return (
    <div className={styles.content}>
      <h1 className={styles.title}>{headline}</h1>
      {body && <article className={styles.body}>{parse(body)}</article>}
    </div>
  );
}

TwoColumnLayoutChildPage.propTypes = {
  headline: PropTypes.string,
  body: PropTypes.string,
};
